import React from "react";

import { MinusIcon, PlusIcon } from "shared/ui";
import styles from "./TradingPanel.module.css";

const QUICK_AMOUNTS = [5, 10, 25, 50, 100];

interface Props {
  amount: number;
  displayValue: string;
  handleChange: (value: string) => void;
  handleBlur: () => void;
  setAmount: (value: number) => void;
  increase: () => void;
  decrease: () => void;
}

export const AmountControl: React.FC<Props> = ({
  amount,
  displayValue,
  handleChange,
  handleBlur,
  setAmount,
  increase,
  decrease,
}) => (
  <>
    <div className={styles.item}>
      <label className={styles.label}>Order Amount</label>
      <div className={styles.control}>
        <button className={styles.tradingButton} onClick={decrease}>
          <MinusIcon />
        </button>
        <input
          className={`${styles.input} ${styles.amountInput}`}
          type="number"
          min={1}
          value={displayValue}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={handleBlur}
        />
        <button className={styles.tradingButton} onClick={increase}>
          <PlusIcon />
        </button>
      </div>
    </div>

    <div className={`${styles.item} ${styles.amounts}`}>
      {QUICK_AMOUNTS.map((value) => (
        <button
          key={value}
          className={`${styles.button} ${amount === value ? styles.active : ""}`}
          onClick={() => setAmount(value)}
        >
          <span className={styles.value}>{value}</span>{" "}
          <span className={styles.unit}>$</span>
        </button>
      ))}
    </div>
  </>
);
